function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

import _JSXStyle from "styled-jsx/style";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import Icon from "./Icon";

var InfoBox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InfoBox, _React$Component);

  var _super = _createSuper(InfoBox);

  function InfoBox() {
    _classCallCheck(this, InfoBox);

    return _super.apply(this, arguments);
  }

  _createClass(InfoBox, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          className = _this$props.className,
          color = _this$props.color,
          icon = _this$props.icon,
          title = _this$props.title,
          children = _this$props.children,
          vertical = _this$props.vertical,
          props = _objectWithoutProperties(_this$props, ["className", "color", "icon", "title", "children", "vertical"]);

      var classNames = classnames('rg-InfoBox', 'bg-white', 'shadow-sm', 'p-3', className, (_classnames = {}, _defineProperty(_classnames, "border-".concat(color), color), _defineProperty(_classnames, 'border-top', vertical), _defineProperty(_classnames, 'border-left', !vertical), _classnames));
      var headerClasses = "text-".concat(color, " font-weight-normal d-flex justify-content-between m-0 mb-3");
      return (
        /*#__PURE__*/
        React.createElement(React.Fragment, null,
        /*#__PURE__*/
        React.createElement("div", _extends({}, props, {
          className: "jsx-2717073164" + " " + (props && props.className != null && props.className || classNames || "")
        }), title &&
        /*#__PURE__*/
        React.createElement("h1", {
          className: "jsx-2717073164" + " " + (headerClasses || "")
        }, title, icon ?
        /*#__PURE__*/
        React.createElement(Icon, {
          name: icon
        }) : null),
        /*#__PURE__*/
        React.createElement("div", {
          className: "jsx-2717073164" + " " + "infobox-body"
        }, children)),
        /*#__PURE__*/
        React.createElement(_JSXStyle, {
          id: "2717073164"
        }, ".rg-InfoBox.jsx-2717073164{border-width:0.55rem !important;-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;}"))
      );
    }
  }]);

  return InfoBox;
}(React.Component);

InfoBox.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.string,
  title: PropTypes.string,
  vertical: PropTypes.bool
};
InfoBox.defaultProps = {
  className: '',
  color: 'info',
  vertical: false
};
InfoBox.displayName = "InfoBox";
export { InfoBox as default };